// components/TokenExpirationWarning.jsx
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import TokenService from '@/services/TokenService';

const TokenExpirationWarning = () => {
    const [showWarning, setShowWarning] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const { token } = useSelector(state => state.auth);

    useEffect(() => {
        const updateWarning = () => {
            if (!token) {
                setShowWarning(false);
                return;
            }

            const timeUntilExpiration = TokenService.getTimeUntilExpiration(token);

            if (timeUntilExpiration && timeUntilExpiration <= 300000) { // 5 minutes
                setShowWarning(true);
                setCountdown(Math.floor(timeUntilExpiration / 1000));
            } else {
                setShowWarning(false);
            }
        };

        updateWarning();
        const interval = setInterval(updateWarning, 1000);

        return () => clearInterval(interval);
    }, [token]);

    useEffect(() => {
        const handleTokenWillExpire = (event) => {
            setShowWarning(true);
            setCountdown(Math.floor(event.detail.timeUntilExpiration / 1000));
        };

        window.addEventListener('tokenWillExpireSoon', handleTokenWillExpire);

        return () => {
            window.removeEventListener('tokenWillExpireSoon', handleTokenWillExpire);
        };
    }, []);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    if (!showWarning) return null;

    return (
        <div className="fixed bottom-4 right-4 z-50 bg-yellow-50 border-l-4 border-yellow-400 p-4 shadow-lg max-w-sm animate-fadeIn">
            <div className="flex items-start">
                <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-yellow-800">
                        Session sur le point d'expirer
                    </h3>
                    <div className="mt-2 text-sm text-yellow-700">
                        <p>Votre session expire dans {formatTime(countdown)}</p>
                        <p className="mt-1 text-xs">Veuillez sauvegarder votre travail.</p>
                    </div>
                    <div className="mt-3 flex space-x-3">
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                        >
                            Rafraîchir
                        </button>
                        <button
                            type="button"
                            onClick={() => setShowWarning(false)}
                            className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                        >
                            Ignorer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TokenExpirationWarning;